import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

export const SOLUTION_CARDS = [
  {
    to: "/solutions/golf-course-lighting",
    title: "Golf Course Lighting",
    desc: "Fairways, greens, and signature holes illuminated for genuine night play.",
    img: "/assets/hero/frame-5.jpg",
    testid: "solution-card-golf",
  },
  {
    to: "/solutions/driving-range-lighting",
    title: "Driving Range Lighting",
    desc: "Evening practice with full ball-flight visibility, bay by bay.",
    img: "/assets/solutions/driving-range-night.jpg",
    testid: "solution-card-range",
  },
  {
    to: "/solutions/sports-lighting",
    title: "Sports Facility Lighting",
    desc: "Athletic fields and outdoor venues lit for training, play, and events.",
    img: "/assets/solutions/sports-field-night.jpg",
    testid: "solution-card-sports",
  },
  {
    to: "/solutions/commercial-lighting",
    title: "Commercial Outdoor Lighting",
    desc: "Large properties, resorts, and grounds with architectural nighttime presence.",
    img: "/assets/solutions/commercial-outdoor-night.jpg",
    testid: "solution-card-commercial",
  },
];

export default function Solutions() {
  return (
    <section className="py-24 sm:py-32 bg-[#0B0D0C] border-y hairline" data-testid="solutions-section">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <Reveal>
          <Eyebrow>Our Solutions</Eyebrow>
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
            <h2 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight max-w-xl">
              Engineered Light for Every Acre
            </h2>
            <p className="text-muted-green text-sm sm:text-base max-w-sm leading-relaxed">
              Fairlume sources professional lighting systems and recommends trusted
              independent installation contractors for facilities of every scale.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {SOLUTION_CARDS.map((s, i) => (
            <Reveal key={s.to} delay={(i % 2) * 0.12}>
              <Link
                to={s.to}
                data-testid={s.testid}
                className="group relative block overflow-hidden rounded-md aspect-[4/3] bg-[#161B19]"
              >
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover opacity-70 transition-all duration-700 group-hover:opacity-90 group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#101214] via-[#101214]/30 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-7 sm:p-9">
                  <h3 className="font-display font-semibold text-xl sm:text-2xl tracking-tight">{s.title}</h3>
                  <p className="mt-2 text-white/60 text-sm max-w-sm">{s.desc}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-xs font-mono-tech uppercase tracking-[0.25em] text-[#A7D7A0]">
                    Explore Solution
                    <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
